class EcoMegaNav extends HTMLElement {
  constructor() {
    super();
    this.closeTimer = null;
    this.desktopMedia = window.matchMedia('(min-width: 990px)');
    this.pointerMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
  }

  connectedCallback() {
    this.menus = Array.from(this.querySelectorAll('[data-mega-menu]'));

    this.menus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (menu.open) this.closeMenus(menu);
      });

      menu.addEventListener('mouseenter', () => {
        if (!this.desktopMedia.matches || !this.pointerMedia.matches) return;
        window.clearTimeout(this.closeTimer);
        this.openMenu(menu);
      });

      menu.addEventListener('mouseleave', () => {
        if (!this.desktopMedia.matches || !this.pointerMedia.matches) return;
        this.closeTimer = window.setTimeout(() => this.closeMenu(menu), 160);
      });

      this.bindCategoryTabs(menu);
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
    window.clearTimeout(this.closeTimer);
  }

  bindCategoryTabs(menu) {
    const tabs = Array.from(menu.querySelectorAll('[data-mega-tab]'));
    if (!tabs.length) return;

    tabs.forEach((tab, index) => {
      ['mouseenter', 'focus', 'click'].forEach((eventName) => {
        tab.addEventListener(eventName, () => this.activateCategory(menu, tab));
      });

      tab.addEventListener('keydown', (event) => {
        const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
      });
    });
  }

  activateCategory(menu, activeTab) {
    const category = activeTab.dataset.megaTab;

    menu.querySelectorAll('[data-mega-tab]').forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    menu.querySelectorAll('[data-mega-category]').forEach((panel) => {
      panel.hidden = panel.dataset.megaCategory !== category;
    });
  }

  openMenu(menu) {
    this.closeMenus(menu);
    menu.open = true;
  }

  closeMenu(menu) {
    menu.open = false;
  }

  closeMenus(except = null) {
    this.menus.forEach((menu) => {
      if (menu !== except) this.closeMenu(menu);
    });
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.closeMenus();
  }

  onDocumentKeydown(event) {
    if (event.key !== 'Escape') return;

    const openMenu = this.menus.find((menu) => menu.open);
    if (!openMenu) return;

    this.closeMenu(openMenu);
    openMenu.querySelector('summary')?.focus();
  }
}

if (!customElements.get('eco-mega-nav')) {
  customElements.define('eco-mega-nav', EcoMegaNav);
}
